import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
export default function LoadingButtonLine({ className, }) {
    return (_jsx("div", { className: "relativ h-1 w-full max-w-[6.25rem] transform overflow-hidden bg-canvas-80", children: _jsx("div", { style: {
                // Remove when we've switched to only tailwind and no longer need !important
                left: "-50%",
                width: "40%",
            }, className: classnames("absolute !h-1 animate-loaderLine bg-neutral-50", className) }) }));
}
//# sourceMappingURL=index.js.map